import { FC, useEffect, useState } from "react";
import styles from "./PendingInfo.module.scss";
import { getTimeLeftDetail, now } from "../../../utils/time";
import { PenaltyInfo } from "../PenaltyInfo/PenaltyInfo";
import { trueLimitsForm } from "../../../utils/true.word.form";
import { useSelector } from "../../../hooks";

interface IPendingBlockProps {
    taskReward: number;
    pendingDate: number;
}

export const PendingBlock: FC<IPendingBlockProps> = ({ pendingDate, taskReward }) => {
    const [timeLeft, setTimeLeft] = useState<string>('');
    const [showPenaltyInfo, setShowPenaltyInfo] = useState(false);
    const [limitsAmount, setLimitsAmount] = useState(0);
    
    const penalty = useSelector(store => store.tasks.joinChannelTasks?.penalty);

    useEffect(() => {
        if (!penalty)
            return;

        const limitsAmount = Object.values(penalty.penalties).reduce((acc, item) => {
            if (item)
                ++acc;
            return acc;
        }, 0);
        setLimitsAmount(limitsAmount);
    }, [penalty]);

    useEffect(() => {
        const timerId = setInterval(() => {
            if (now() > pendingDate) {
                clearInterval(timerId);
                return;
            }

            now() < pendingDate
                ? setTimeLeft(getTimeLeftDetail(pendingDate, -1, 2))
                : setTimeLeft('');
        }, 1000);

        return () => clearInterval(timerId);
    }, [pendingDate]);

    return (
        <>
            <div className={ styles.container }>
                <div className={styles.info}>
                    <span className={styles.label}>На проверке</span>
                    <div className={styles.timer}>
                        {timeLeft}
                    </div>
                </div>

                <div className={styles.detail}>
                    <div onClick={ () => setShowPenaltyInfo(true) }>
                        {`Мы вводим ${limitsAmount} ${trueLimitsForm(limitsAmount)} для защиты наших партнёров, без которых не было бы ваших заданий.`}
                    </div>

                    <div className={ styles.link } onClick={ () => setShowPenaltyInfo(true) }>
                        Как убрать ограничения?
                    </div>
                </div>
            </div>

            { showPenaltyInfo &&
                <PenaltyInfo taskReward={ taskReward } onClose={ () => setShowPenaltyInfo(false) } />
            }
        </>
    );
}